import useSWR from 'swr';
import { PLAYER_ACCOUNTS_KEY } from '@/helpers/constants';
import type { CurrencyCode } from '@/helpers/currency';
import { fetcherSS } from '@/modules/api';
import { useGetCommonStore } from '@/store';

export interface IAccount {
  currency: CurrencyCode;
  amountCents: number;
  availableToCashoutCents: number;
  availableToBetWithLockedCents: number;
  active: boolean;
}

export interface IPlayerBalance extends IAccount {
  lockedCents: number;
  lockedByBonusCents: number;
  lockedByWagerCents: number;
  depositAvailable: boolean;
  hiddenAt: string | null;
  selectedLotteryId: number | null;
}

export const usePlayerAccounts = () => {
  const useCommonStore = useGetCommonStore();
  const userId = useCommonStore.use.user()?.id;

  const {
    data = [],
    error,
    isLoading,
    mutate,
  } = useSWR<IAccount[]>(userId ? PLAYER_ACCOUNTS_KEY : null, fetcherSS);

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};
